/** Shared state for host→MFE route sync (avoids stale singleton pushing the host backward). */
export const hostRouteSyncState = {
    isApplyingHostRoute: false,
};
